import React from "react";
import { useConfig } from "../contexts/ConfigContext";

interface FormStepperProps {
  currentStep: number;
}

const FormStepper: React.FC<FormStepperProps> = ({ currentStep }) => {
  const { config } = useConfig();

  const steps = [
    { number: 1, title: "Permit Details" },
    { number: 2, title: "Vehicle Details" },
    { number: 3, title: "Personal Information" },
    ...(config?.documents.enabled
      ? [{ number: 4, title: "Required Documents" }]
      : []),
  ];

  return (
    <div className="mb-8">
      <div className="flex justify-center items-center">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            {/* Step circle */}
            <div className="flex flex-col items-center relative">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  currentStep >= step.number
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-600"
                }`}
              >
                {currentStep > step.number ? (
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                ) : (
                  step.number
                )}
              </div>
              <p
                className={`text-sm mt-2 font-medium ${
                  currentStep >= step.number ? "text-blue-600" : "text-gray-500"
                }`}
              >
                {step.title}
              </p>
            </div>
            {/* Connector line */}
            {index < steps.length - 1 && (
              <div
                className={`h-1 w-12 md:w-24 mx-2 ${
                  currentStep > step.number ? "bg-blue-600" : "bg-gray-200"
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default FormStepper;
